import { getSafeLocalStorage } from '@noah-labs/fe-shared-util-shared';
import { parseTruthyEnv } from '@noah-labs/shared-util-vanilla';

export const disableTransitions = parseTruthyEnv(
  getSafeLocalStorage()?.getItem('disableTransitions'),
);
